export const routeToLandingPage = () => {
  const [, site, domain] = location.host.split(".");
  if (domain === void 0) {
    return false;
  }
  location.assign("https://" + site + "." + domain);
  return true;
};
